import React, { Fragment, PureComponent } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import { msg } from 'api';
import { priceFormat } from 'apps/products/utils/priceFormat';
import PriceType from 'apps/products/models/PriceType';
import WeightType from 'apps/products/models/WeightUnits';
import PriceTypical from 'apps/fops/components/fopPartials/pricePartials/PriceTypical';

import Icon from 'widgets/Icon/Icon';

export default class Price extends PureComponent {
  static propTypes = {
    price: PropTypes.shape({
      message: PropTypes.string,
      current: PropTypes.number,
      previous: PropTypes.number,
      lpp: PropTypes.bool,
      unit: PropTypes.shape({
        price: PropTypes.number,
        per: PropTypes.string,
      }),
    }).isRequired,
    catchWeightMinWeight: PropTypes.object,
    catchWeightMaxWeight: PropTypes.object,
    productWarning: PropTypes.object,
    isCustomerSubscribedToSmartPass: PropTypes.bool,
    isValueDeliveredProduct: PropTypes.bool,
    showZerosAfterPounds: PropTypes.bool,
  };

  static defaultProps = {
    showZerosAfterPounds: true,
  };

  renderPriceIcons = () => {
    const {
      price: { lpp = false } = {},
      isCustomerSubscribedToSmartPass,
      isValueDeliveredProduct,
    } = this.props;

    return (
      <>
        {isCustomerSubscribedToSmartPass && <Icon name="smart-pass" />}
        {lpp && (
          <Link className="bop-price__lppLink" to={msg.product.lppLink}>
            <Icon name="low-price-promise" className="bop-price__lpp" />
          </Link>
        )}
        {isValueDeliveredProduct && (
          <Link className="bop-price__valueDeliveredLink" to={{ pathname: msg.product.valueDeliveredLink }}>
            <Icon name="value-delivered" className="bop-price__value-delivered" />
          </Link>
        )}
      </>
    );
  }

  renderPrice = () => {
    const {
      price,
      productWarning,
      showZerosAfterPounds,
    } = this.props;

    const pricePer = price.unit && price.unit.price > 0 && (
      <span className="bop-price__per">
        {priceFormat({
          value: price.unit.price,
          zeroAfterPound: showZerosAfterPounds,
          showPenceFraction: true,
        })} {price.unit.per}
      </span>
    );

    const isOfferPrice = price.previous || price.type === PriceType.OFFER;

    return (
      <div
        className="bop-price__wrapper"
        itemProp="offers"
        itemScope=""
        itemType="http://schema.org/Offer"
      >
        <PriceTypical
          {...price}
          className="bop-price__typical"
        />
        {!!price.current && (
          <h2
            className={`bop-price__current ${isOfferPrice ? 'bop-price__current--offer' : ''}`}
          >
            <meta itemProp="price" content={price.current} />
            <meta itemProp="priceCurrency" content="GBP" />
            {priceFormat({ value: price.current, zeroAfterPound: showZerosAfterPounds })}
          </h2>
        )}

        { this.renderPriceIcons() }

        { price.previous && (
          <span className="bop-price__old">
            {priceFormat({ value: price.previous, zeroAfterPound: showZerosAfterPounds })}
          </span>
        )}

        {productWarning && <div className="error-message">{productWarning}</div>}
        {pricePer}
      </div>
    );
  };

  render() {
    const {
      price,
      catchWeightMinWeight,
      catchWeightMaxWeight,
    } = this.props;

    const productPrice = this.renderPrice();

    const catchWeightMin = catchWeightMinWeight
      && `Min. weight: ${catchWeightMinWeight.value} ${WeightType[catchWeightMinWeight.unit]}`;
    const catchWeightMax = catchWeightMaxWeight
      && `Max. weight: ${catchWeightMaxWeight.value} ${WeightType[catchWeightMaxWeight.unit]}`;

    const typicalSize = (
      <div className="bop-typicalSize">
        {catchWeightMinWeight && <p className="bop-minWeight gn-content__paragraph--small">{catchWeightMin}</p>}
        {catchWeightMaxWeight && <p className="bop-maxWeight gn-content__paragraph--small">{catchWeightMax}</p>}
      </div>);

    return (
      <Fragment>
        {productPrice}
        {price.messageType === PriceType.TYPICAL_REGULAR && typicalSize}
      </Fragment>);
  }
}
